/**
 * Gate for the /partner/* route subtree (reseller/commercial console).
 *   1. No JWT → /login.
 *   2. JWT but not a partner (partner/me 403) → /dashboard.
 *   3. Partner → render the console.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { isAuthenticated } from "@/lib/auth";
import { usePartnerMe } from "@/lib/partner";
import { Spinner } from "./Spinner";

export function PartnerRouteGuard() {
  const location = useLocation();
  const me = usePartnerMe();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (me.isLoading) return <Spinner fullscreen label="Loading…" />;
  if (me.isError || !me.data) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
